import React from 'react'
import { Link } from 'react-router-dom'
import Header from '../components/layout/Header'
import Footer from '../components/layout/Footer'
import GlassContainer from '../components/ui/GlassContainer'

const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen bg-primary-900 noise-bg">
      <Header />
      <main className="pt-24 pb-16">
        <div className="container mx-auto px-4 max-w-4xl">
          <GlassContainer variant="prominent" className="p-8">
            <div className="mb-8">
              <Link to="/" className="text-accent-blue hover:text-accent-blue/80 transition-colors mb-4 inline-block">
                &larr; Back to Home
              </Link>
              <h1 className="heading-xl mb-4">Privacy Policy</h1>
              <p className="body-lg text-text-muted">Last updated: March 2026</p>
            </div>

            <div className="prose prose-invert max-w-none">
              <section className="mb-8">
                <h2 className="heading-lg mb-4">Introduction</h2>
                <p className="body-lg mb-4">
                  CongressMCP is a free, open-source MCP server for congressional data. This privacy policy
                  covers this website (the project landing page) and the CongressMCP software.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="heading-lg mb-4">Information We Collect</h2>
                <h3 className="heading-md mb-3">This Website</h3>
                <p className="body-lg mb-4">
                  This website uses Cloudflare Web Analytics, which collects anonymous, aggregated visitor
                  data. It does not use cookies, does not collect personal information, and does not track
                  individual users.
                </p>
                <h3 className="heading-md mb-3">CongressMCP Software</h3>
                <p className="body-lg mb-4">
                  The CongressMCP server runs locally on your machine. It does not send any data to us,
                  does not phone home, and does not collect usage analytics. Your API requests go directly
                  from your machine to the Congress.gov API.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="heading-lg mb-4">Third-Party Services</h2>
                <ul className="list-disc pl-6 space-y-2">
                  <li className="body-lg">
                    <strong>Congress.gov API</strong> — Your API calls go directly to this government service.
                    See their privacy policy at api.congress.gov.
                  </li>
                  <li className="body-lg">
                    <strong>Cloudflare Web Analytics</strong> — Used on this website only. Privacy-focused,
                    no cookies, no PII collection.
                  </li>
                </ul>
              </section>

              <section className="mb-8">
                <h2 className="heading-lg mb-4">Open Source</h2>
                <p className="body-lg mb-4">
                  CongressMCP is open source under the Sustainable Use License. The source code is publicly available
                  on{' '}
                  <a href="https://github.com/amurshak/congressMCP" target="_blank" rel="noopener noreferrer" className="text-accent-blue hover:text-accent-blue/80">
                    GitHub
                  </a>{' '}
                  for inspection.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="heading-lg mb-4">Contact</h2>
                <p className="body-lg">
                  Questions? Open an issue on{' '}
                  <a href="https://github.com/amurshak/congressMCP/issues" target="_blank" rel="noopener noreferrer" className="text-accent-blue hover:text-accent-blue/80">
                    GitHub
                  </a>.
                </p>
              </section>
            </div>
          </GlassContainer>
        </div>
      </main>
      <Footer />
    </div>
  )
}

export default PrivacyPolicy
